// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --primary-color: #2563eb;
  --primary-hover: #1d4ed8;
  --secondary-color: #64748b;
  --background-color: #f8fafc;
  --card-background: #ffffff;
  --border-color: #e2e8f0;
  --text-primary: #1e293b;
  --text-secondary: #64748b;
  --error-color: #ef4444;
  --success-color: #10b981;
  --warning-color: #f59e0b;
  --shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1),
    0 2px 4px -1px rgba(0, 0, 0, 0.06);
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: "Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
}

body {
  background-color: var(--background-color);
  color: var(--text-primary);
}

/* PosConsultPageHome.css */
.spin {
  animation: spin 1s linear infinite;
}
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.button-cashier {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  background-color: var(--primary-color);
  color: white;
  border: none;
  border-radius: 0.375rem;
  font-size: 0.875rem;
  font-weight: 500;
  border: 1px solid var(--border-color);
  cursor: pointer;
  transition: background-color 0.2s;
}

.button-cashier:hover {
  background-color: var(--primary-hover);
}

.app-container {
  height: 85vh;
  overflow-y: auto;
  margin: 0 auto;
  padding: 1rem;
}

/* Header Styles */
.app-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;
  flex-wrap: wrap;
  gap: 1rem;
}

.logo-container {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.logo-icon {
  color: var(--primary-color);
}

.app-header h1 {
  font-size: 1.75rem;
  font-weight: 600;
  color: var(--text-primary);
}

.header-controls {
  display: flex;
  gap: 1.5rem;
  align-items: center;
  flex-wrap: wrap;
}

.date-picker {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background-color: var(--card-background);
  padding: 0.5rem 0.75rem;
  border-radius: 0.5rem;
  border: 1px solid var(--border-color);
}

.date-picker input {
  border: none;
  outline: none;
  font-size: 0.875rem;
  color: var(--text-primary);
  background: transparent;
}

.date-icon,
.filter-icon,
.search-icon {
  color: var(--secondary-color);
}

/* Search Container */
.search-container {
  position: relative;
  margin-bottom: 1.5rem;
}

.search-container input {
  width: 100%;
  padding: 0.75rem 1rem 0.75rem 2.5rem;
  border-radius: 0.5rem;
  border: 1px solid var(--border-color);
  font-size: 1rem;
  outline: none;
  transition: border-color 0.2s;
}

.search-container input:focus {
  border-color: var(--primary-color);
}

.search-icon {
  position: absolute;
  left: 0.75rem;
  top: 50%;
  transform: translateY(-50%);
}

/* Patient Card Styles */
.patients-list {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.patient-card {
  display: flex;
  background-color: var(--card-background);
  border-radius: 0.5rem;
  padding: 1rem;
  box-shadow: var(--shadow);
  transition: transform 0.2s, box-shadow 0.2s;
  gap: 1rem;
  align-items: center;
}

.patient-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1),
    0 4px 6px -2px rgba(0, 0, 0, 0.05);
}

.patient-avatar {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  background-color: #e2e8f0;
  border-radius: 50%;
  color: var(--secondary-color);
  flex-shrink: 0;
}

.patient-info {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin-left: 3rem;
}

.patient-main-info {
  display: flex;
  justify-content: space-between;
  gap: 1rem;
  flex-wrap: wrap;
}

.patient-name-container {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.patient-name {
  font-size: 1rem;
  font-weight: 600;
  color: var(--text-primary);
}

.patient-cpf {
  font-size: 0.875rem;
  color: var(--text-secondary);
}

.btn-whatsapp{
  background: #25d366;
  width: 48px;
  height: 48px;
}

.btn-whatsapp:hover{
  background: #128c7e;
  cursor: pointer;
}

.patient-exam-info {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  text-align: right;
}

.exam-type {
  font-size: 0.875rem;
  font-weight: 500;
  color: var(--text-primary);
}

.exam-code {
  font-size: 0.75rem;
  color: var(--text-secondary);
}

.patient-secondary-info {
  display: flex;
  justify-content: space-between;
  color: var(--text-secondary);
  font-size: 0.75rem;
  margin-top: 0.25rem;
}

.patient-actions {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.budget-button {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 0.75rem;
  background-color: deepskyblue;
  color: white;
  border: none;
  border-radius: 0.375rem;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;
}

.budget-button:hover {
  background-color: var(--primary-hover);
}

.budget-button:disabled {
  background-color: #d6d6d6; 
  color: #a1a1a1;
  cursor: not-allowed;
  opacity: 0.7; 
}

.procedure-button {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 0.75rem;
  background-color: var(--primary-color);
  color: white;
  border: none;
  border-radius: 0.375rem;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;
}

.procedure-button:hover {
  background-color: var(--primary-hover);
}

.scheduled-button {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 0.75rem;
  background-color: var(--success-color);
  color: white;
  border: none;
  border-radius: 0.375rem;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;
}

.scheduled-button:hover {
  background-color: #059669;
}

.details-button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  background-color: transparent;
  border: 1px solid var(--border-color);
  border-radius: 50%;
  color: var(--secondary-color);
  cursor: pointer;
  transition: background-color 0.2s, color 0.2s;
}

.details-button:hover {
  background-color: var(--border-color);
  color: var(--text-primary);
}

.payment-card-button {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 0.75rem;
  background-color: #f59e0b;
  color: white;
  border: none;
  border-radius: 0.375rem;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;
}

.payment-card-button:hover {
  background-color: #d97706;
}

.no-results {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 3rem;
  color: var(--text-secondary);
  text-align: center;
  gap: 1rem;
}

/* Modal Styles */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
  padding: 1rem;
}

.procedures-modal {
  background-color: var(--card-background);
  border-radius: 0.5rem;
  width: 100%;
  max-width: 700px;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1),
    0 10px 10px -5px rgba(0, 0, 0, 0.04);
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 1.5rem;
  border-bottom: 1px solid var(--border-color);
  flex-shrink: 0;
}

.modal-header h2 {
  font-size: 1.25rem;
  font-weight: 600;
}

.close-button {
  background: transparent;
  border: none;
  color: var(--text-secondary);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.25rem;
  border-radius: 0.25rem;
  transition: background-color 0.2s, color 0.2s;
}

.close-button:hover {
  background-color: var(--border-color);
  color: var(--text-primary);
}

.modal-content-scrollable {
  flex: 1 1;
  overflow-y: auto;
  padding-bottom: 1rem;
}

.modal-search {
  padding: 1rem 1.5rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  border-bottom: 1px solid var(--border-color);
}

.search-input {
  position: relative;
  flex: 1 1;
  min-width: 200px;
}

.search-input input {
  width: 100%;
  padding: 0.5rem 0.75rem 0.5rem 2rem;
  border-radius: 0.375rem;
  border: 1px solid var(--border-color);
  font-size: 0.875rem;
  outline: none;
}

.search-input svg {
  position: absolute;
  left: 0.5rem;
  top: 50%;
  transform: translateY(-50%);
  color: var(--text-secondary);
}

.sector-filter {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.875rem;
}

.sector-filter select {
  padding: 0.5rem;
  border-radius: 0.375rem;
  border: 1px solid var(--border-color);
  font-size: 0.875rem;
  outline: none;
  background-color: var(--card-background);
}

.select-all-container {
  padding: 0.5rem 0;
  border-top: 1px dashed var(--border-color);
}

.select-all-label {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.875rem;
  cursor: pointer;
}

.sector-buttons {
  padding-top: 0.5rem;
  border-top: 1px dashed var(--border-color);
}

.sector-buttons-title {
  font-size: 0.875rem;
  margin-bottom: 0.5rem;
  color: var(--text-secondary);
}

.sector-buttons-container {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.sector-select-button {
  padding: 0.375rem 0.75rem;
  background-color: #f1f5f9;
  border: 1px solid var(--border-color);
  border-radius: 0.375rem;
  font-size: 0.75rem;
  cursor: pointer;
  transition: background-color 0.2s, border-color 0.2s;
}

.sector-select-button:hover {
  background-color: #e2e8f0;
  border-color: #cbd5e1;
}

.sector-select-button.selected {
  background-color: #eff6ff;
  border-color: var(--primary-color);
  color: var(--primary-color);
}

.error-message {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem 1.5rem;
  background-color: #fee2e2;
  color: var(--error-color);
  font-size: 0.875rem;
}

.procedures-list {
  flex: 1 1;
  overflow-y: auto;
  padding: 1rem 1.5rem;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.procedure-item {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  padding: 0.75rem;
  border-radius: 0.375rem;
  border: 1px solid var(--border-color);
  cursor: pointer;
  transition: background-color 0.2s, border-color 0.2s;
}

.procedure-item:hover {
  background-color: #f1f5f9;
}

.procedure-item.selected {
  border-color: var(--primary-color);
  background-color: #eff6ff;
}

.procedure-checkbox {
  padding-top: 0.25rem;
}

.procedure-details {
  flex: 1 1;
}

.procedure-details h4 {
  font-size: 0.875rem;
  font-weight: 600;
  margin-bottom: 0.25rem;
}

.procedure-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  font-size: 0.75rem;
  color: var(--text-secondary);
}

.no-procedures {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2rem;
  color: var(--text-secondary);
}

.modal-footer {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  padding: 1rem 1.5rem;
  border-top: 1px solid var(--border-color);
  background-color: var(--card-background);
  flex-shrink: 0;
}

.available-doctors {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.875rem;
  color: var(--text-secondary);
  padding-bottom: 0.75rem;
  border-bottom: 1px dashed var(--border-color);
}

.modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
}

.cancel-button {
  padding: 0.5rem 1rem;
  background-color: transparent;
  border: 1px solid var(--border-color);
  border-radius: 0.375rem;
  font-size: 0.875rem;
  font-weight: 500;
  color: var(--text-secondary);
  cursor: pointer;
  transition: background-color 0.2s;
}

.cancel-button:hover {
  background-color: #f1f5f9;
}

.schedule-button {
  padding: 0.5rem 1rem;
  background-color: var(--primary-color);
  color: white;
  border: none;
  border-radius: 0.375rem;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s, opacity 0.2s;
}

.schedule-button:hover:not(:disabled) {
  background-color: var(--primary-hover);
}

.schedule-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* Scheduled Procedures Modal Styles */
.scheduled-procedures-modal {
  max-width: 800px;
  display: flex;
  flex-direction: column;
  height: 90vh;
}

.scheduled-procedures-list {
  padding: 1rem 1.5rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.scheduled-procedure-card {
  background-color: white;
  border-radius: 0.5rem;
  border: 1px solid var(--border-color);
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.scheduled-procedure-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.75rem 1rem;
  background-color: #f8fafc;
  border-bottom: 1px solid var(--border-color);
}

.scheduled-date-time {
  display: flex;
  gap: 1rem;
}

.scheduled-date,
.scheduled-time {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.875rem;
}

.scheduled-status {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.875rem;
  font-weight: 500;
}

.status-icon.status-confirmed {
  color: var(--primary-color);
}

.status-icon.status-completed {
  color: var(--success-color);
}

.status-icon.status-canceled {
  color: var(--error-color);
}

.status-icon.status-pending {
  color: var(--warning-color);
}

.scheduled-procedure-content {
  padding: 1rem;
}

.scheduled-doctor {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 1rem;
  font-size: 0.875rem;
  font-weight: 500;
}

.doctor-specialty {
  font-weight: normal;
  color: var(--text-secondary);
  margin-left: 0.25rem;
}

.scheduled-procedures {
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin: 0.5rem 0 1rem;
}

.scheduled-procedures li {
  display: flex;
  justify-content: space-between;
  font-size: 0.875rem;
  padding-bottom: 0.5rem;
  border-bottom: 1px dashed var(--border-color);
}

.scheduled-total {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 0.5rem;
  font-weight: 500;
  font-size: 0.875rem;
}

.total-price {
  color: var(--primary-color);
  font-size: 1rem;
}

.scheduled-comments {
  margin-top: 1rem;
  padding: 0.75rem;
  background-color: #f8fafc;
  border-radius: 0.375rem;
  font-size: 0.875rem;
}

.scheduled-comments h4 {
  margin-bottom: 0.5rem;
  font-size: 0.875rem;
  color: var(--text-secondary);
}

.scheduled-procedure-actions {
  display: flex;
  justify-content: flex-end;
  gap: 0.75rem;
  padding: 0.75rem 1rem;
  border-top: 1px solid var(--border-color);
  background-color: #f8fafc;
}

.reschedule-button,
.cancel-appointment-button,
.view-results-button,
.payment-button {
  padding: 0.5rem 0.75rem;
  border-radius: 0.375rem;
  font-size: 0.75rem;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.reschedule-button {
  background-color: #f8fafc;
  border: 1px solid var(--border-color);
  color: var(--text-secondary);
}

.reschedule-button:hover {
  background-color: #f1f5f9;
}

.cancel-appointment-button {
  background-color: #fee2e2;
  border: 1px solid #fecaca;
  color: #b91c1c;
}

.cancel-appointment-button:hover {
  background-color: #fecaca;
}

.view-results-button {
  background-color: #ecfdf5;
  border: 1px solid #d1fae5;
  color: #047857;
}

.view-results-button:hover {
  background-color: #d1fae5;
}

.payment-button {
  background-color: #fffbeb;
  border: 1px solid #fef3c7;
  color: #b45309;
}

.payment-button:hover {
  background-color: #fef3c7;
}

.no-scheduled-procedures {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 3rem 1rem;
  text-align: center;
  gap: 1rem;
  color: var(--text-secondary);
}

.schedule-new-button {
  padding: 0.75rem 1.5rem;
  background-color: var(--primary-color);
  color: white;
  border: none;
  border-radius: 0.375rem;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;
  margin-top: 1rem;
}

.schedule-new-button:hover {
  background-color: var(--primary-hover);
}

/* Payment Modal Styles */
.payment-modal {
  max-width: 800px;
  display: flex;
  flex-direction: column;
  height: 90vh;
}

.payment-patient-info {
  display: flex;
  justify-content: space-between;
  padding: 1rem 1.5rem;
  background-color: #f8fafc;
  border-bottom: 1px solid var(--border-color);
}

.payment-patient-name,
.payment-date {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.875rem;
}

.payment-patient-name strong,
.payment-date strong {
  font-weight: 600;
}

.payment-search-container {
  padding: 1rem 1.5rem;
  border-bottom: 1px solid var(--border-color);
}

.payment-selection-options {
  padding: 0.5rem 1.5rem;
  border-bottom: 1px solid var(--border-color);
}

.select-by-sector {
  margin-top: 0.75rem;
  padding-top: 0.75rem;
  border-top: 1px dashed var(--border-color);
}

.select-by-sector-title {
  font-size: 0.875rem;
  margin-bottom: 0.5rem;
  color: var(--text-secondary);
}

.payment-procedures-list {
  padding: 1rem 1.5rem;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  max-height: 300px;
  overflow-y: auto;
}

.payment-procedure-item {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.75rem;
  border-radius: 0.375rem;
  border: 1px solid var(--border-color);
  cursor: pointer;
  transition: background-color 0.2s, border-color 0.2s;
}

.payment-procedure-item:hover {
  background-color: #f1f5f9;
}

.payment-procedure-item.selected {
  border-color: var(--primary-color);
  background-color: #eff6ff;
}

.payment-procedure-checkbox {
  display: flex;
  align-items: center;
}

.payment-procedure-details {
  flex: 1 1;
}

.payment-procedure-details h4 {
  font-size: 0.875rem;
  font-weight: 600;
  margin-bottom: 0.25rem;
}

.payment-procedure-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  font-size: 0.75rem;
  color: var(--text-secondary);
}

.payment-procedure-price {
  font-weight: 600;
  color: var(--primary-color);
  font-size: 0.875rem;
}

.payment-summary {
  padding: 1rem 1.5rem;
  border-top: 1px solid var(--border-color);
  border-bottom: 1px solid var(--border-color);
}

.payment-subtotal {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 0.875rem;
  font-weight: 500;
  margin-bottom: 1rem;
}

.payment-subtotal-value {
  font-weight: 600;
}

.payment-discount-section {
  background-color: #f8fafc;
  border-radius: 0.5rem;
  padding: 1rem;
  margin-bottom: 1rem;
}

.payment-discount-section h4 {
  font-size: 0.875rem;
  font-weight: 600;
  margin-bottom: 0.75rem;
  color: var(--text-secondary);
}

.discount-options {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.discount-type-selector {
  display: flex;
  gap: 1rem;
}

.discount-type-option {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 0.75rem;
  border-radius: 0.375rem;
  border: 1px solid var(--border-color);
  font-size: 0.75rem;
  cursor: pointer;
  transition: background-color 0.2s, border-color 0.2s;
}

.discount-type-option:hover {
  background-color: #f1f5f9;
}

.discount-type-option.selected {
  border-color: var(--primary-color);
  background-color: #eff6ff;
}

.discount-type-option input {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
}

.discount-type-option svg {
  color: var(--primary-color);
}

.discount-value-input {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.discount-value-input label {
  font-size: 0.75rem;
  color: var(--text-secondary);
}

.discount-input-wrapper {
  position: relative;
}

.discount-input-icon {
  position: absolute;
  left: 0.5rem;
  top: 50%;
  transform: translateY(-50%);
  color: var(--text-secondary);
}

.discount-value-input input {
  width: 100%;
  padding: 0.5rem 0.5rem 0.5rem 2rem;
  border-radius: 0.375rem;
  border: 1px solid var(--border-color);
  font-size: 0.875rem;
  outline: none;
}

.discount-reason {
  margin-top: 0.75rem;
}

.discount-reason label {
  display: block;
  font-size: 0.75rem;
  color: var(--text-secondary);
  margin-bottom: 0.5rem;
}

.discount-reason input {
  width: 100%;
  padding: 0.5rem 0.75rem;
  border-radius: 0.375rem;
  border: 1px solid var(--border-color);
  font-size: 0.875rem;
  outline: none;
}

.discount-summary {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 0.75rem;
  padding-top: 0.75rem;
  border-top: 1px dashed var(--border-color);
  font-size: 0.875rem;
}

.discount-value {
  font-weight: 600;
  color: var(--error-color);
}

.payment-total {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 0.875rem;
  font-weight: 500;
  padding-top: 0.75rem;
  margin-top: 0.5rem;
  border-top: 1px solid var(--border-color);
}

.payment-total-label {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.edit-total-button {
  background: transparent;
  border: none;
  color: var(--text-secondary);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.25rem;
  border-radius: 0.25rem;
  transition: background-color 0.2s, color 0.2s;
}

.edit-total-button:hover {
  background-color: #f1f5f9;
  color: var(--primary-color);
}

.edit-total-actions {
  display: flex;
  gap: 0.25rem;
}

.save-total-button,
.cancel-edit-button {
  background: transparent;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.25rem;
  border-radius: 0.25rem;
  transition: background-color 0.2s, color 0.2s;
}

.save-total-button {
  color: var(--success-color);
}

.save-total-button:hover {
  background-color: #ecfdf5;
}

.cancel-edit-button {
  color: var(--error-color);
}

.cancel-edit-button:hover {
  background-color: #fee2e2;
}

.custom-total-input {
  position: relative;
}

.custom-total-icon {
  position: absolute;
  left: 0.5rem;
  top: 50%;
  transform: translateY(-50%);
  color: var(--text-secondary);
}

.custom-total-input input {
  padding: 0.5rem 0.5rem 0.5rem 2rem;
  border-radius: 0.375rem;
  border: 1px solid var(--primary-color);
  font-size: 0.875rem;
  outline: none;
  width: 150px;
  background-color: #eff6ff;
}

.payment-total-value {
  font-size: 1.125rem;
  color: var(--primary-color);
  font-weight: 600;
}

.payment-methods {
  padding: 1rem 1.5rem;
  border-bottom: 1px solid var(--border-color);
}

.payment-methods h3 {
  font-size: 0.875rem;
  font-weight: 600;
  margin-bottom: 0.75rem;
}

.payment-methods-options {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
  margin-bottom: 1rem;
}

.payment-method-option {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem 1rem;
  border-radius: 0.375rem;
  border: 1px solid var(--border-color);
  font-size: 0.875rem;
  cursor: pointer;
  transition: background-color 0.2s, border-color 0.2s;
}

.payment-method-option:hover {
  background-color: #f1f5f9;
}

.payment-method-option.selected {
  border-color: var(--primary-color);
  background-color: #eff6ff;
}

.payment-method-option input {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
}

.payment-method-option svg {
  color: var(--primary-color);
}

.payment-installments {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-top: 0.75rem;
  padding-top: 0.75rem;
  border-top: 1px dashed var(--border-color);
}

.payment-installments label {
  font-size: 0.875rem;
}

.payment-installments select {
  padding: 0.5rem;
  border-radius: 0.375rem;
  border: 1px solid var(--border-color);
  font-size: 0.875rem;
  outline: none;
  background-color: var(--card-background);
}

/* Estilos para o upload de comprovante */
.payment-receipt-upload {
  margin-top: 1.5rem;
  padding-top: 1.5rem;
  border-top: 1px dashed var(--border-color);
}

.payment-receipt-upload h4 {
  font-size: 0.875rem;
  font-weight: 600;
  margin-bottom: 0.5rem;
  color: var(--text-secondary);
}

.upload-description {
  font-size: 0.75rem;
  color: var(--text-secondary);
  margin-bottom: 1rem;
}

.file-input-hidden {
  display: none;
}

.upload-button {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  width: 100%;
  padding: 0.75rem;
  background-color: #f8fafc;
  border: 1px dashed var(--border-color);
  border-radius: 0.375rem;
  color: var(--text-secondary);
  font-size: 0.875rem;
  cursor: pointer;
  transition: background-color 0.2s, border-color 0.2s;
}

.upload-button:hover {
  background-color: #f1f5f9;
  border-color: var(--primary-color);
  color: var(--primary-color);
}

.receipt-preview {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.75rem;
  background-color: #f8fafc;
  border: 1px solid var(--border-color);
  border-radius: 0.375rem;
  margin-bottom: 1rem;
}

.receipt-file-info {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.image-preview {
  width: 60px;
  height: 60px;
  border-radius: 0.25rem;
  overflow: hidden;
  border: 1px solid var(--border-color);
  background-color: white;
}

.image-preview img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.file-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 60px;
  height: 60px;
  background-color: #eff6ff;
  border-radius: 0.25rem;
  color: var(--primary-color);
}

.file-details {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.file-name {
  font-size: 0.875rem;
  font-weight: 500;
  color: var(--text-primary);
  max-width: 200px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.file-size {
  font-size: 0.75rem;
  color: var(--text-secondary);
}

.remove-file-button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  background-color: #fee2e2;
  border: none;
  border-radius: 50%;
  color: var(--error-color);
  cursor: pointer;
  transition: background-color 0.2s;
}

.remove-file-button:hover {
  background-color: #fecaca;
}

.payment-actions {
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
}

.process-payment-button {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem 1.5rem;
  background-color: var(--primary-color);
  color: white;
  border: none;
  border-radius: 0.375rem;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s, opacity 0.2s;
}

.process-payment-button:hover:not(:disabled) {
  background-color: var(--primary-hover);
}

.process-payment-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* Payment Confirmation Styles */
.payment-confirmation {
  padding: 1.5rem;
}

.payment-confirmation-header {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1rem;
  background-color: #fffbeb;
  border-radius: 0.5rem;
  margin-bottom: 1.5rem;
  border-left: 4px solid var(--warning-color);
}

.payment-confirmation-header .confirmation-icon {
  color: var(--warning-color);
}

.payment-confirmation-header p {
  font-size: 0.875rem;
  color: #92400e;
}

.payment-confirmation-details {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1.5rem;
}

.payment-confirmation-section {
  background-color: #f8fafc;
  border-radius: 0.5rem;
  padding: 1rem;
  border: 1px solid var(--border-color);
}

.payment-confirmation-section h3 {
  font-size: 0.875rem;
  font-weight: 600;
  margin-bottom: 0.75rem;
  padding-bottom: 0.5rem;
  border-bottom: 1px dashed var(--border-color);
}

.payment-confirmation-section p {
  font-size: 0.875rem;
  margin-bottom: 0.5rem;
}

.payment-confirmation-procedures {
  list-style: none;
  margin-top: 0.5rem;
  max-height: 200px;
  overflow-y: auto;
}

.payment-confirmation-procedures li {
  display: flex;
  justify-content: space-between;
  font-size: 0.875rem;
  padding: 0.5rem 0;
  border-bottom: 1px dashed var(--border-color);
}

.payment-confirmation-actions {
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  margin-top: 1.5rem;
}

.receipt-preview-confirmation {
  margin-top: 0.5rem;
  max-height: 200px;
  overflow: hidden;
  border-radius: 0.375rem;
  border: 1px solid var(--border-color);
}

.receipt-preview-confirmation img {
  width: 100%;
  height: auto;
  max-height: 200px;
  object-fit: contain;
}

.receipt-section {
  grid-column: span 2;
}

.back-button {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem 1.5rem;
  background-color: transparent;
  border: 1px solid var(--border-color);
  border-radius: 0.375rem;
  color: var(--text-secondary);
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;
}

.back-button:hover {
  background-color: #f1f5f9;
}

.confirm-payment-button {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem 1.5rem;
  background-color: var(--success-color);
  color: white;
  border: none;
  border-radius: 0.375rem;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;
}

.confirm-payment-button:hover {
  background-color: #059669;
}

/* Payment Success Styles */
.payment-success {
  padding: 2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.payment-success-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 80px;
  height: 80px;
  background-color: #ecfdf5;
  border-radius: 50%;
  color: var(--success-color);
  margin-bottom: 1.5rem;
}

.payment-success h3 {
  font-size: 1.25rem;
  font-weight: 600;
  margin-bottom: 0.5rem;
  color: var(--success-color);
}

.payment-success p {
  font-size: 0.875rem;
  color: var(--text-secondary);
  margin-bottom: 1.5rem;
}

.payment-success-details {
  background-color: #f8fafc;
  border-radius: 0.5rem;
  padding: 1.5rem;
  width: 100%;
  max-width: 400px;
  margin: 0 auto 1.5rem;
  border: 1px solid var(--border-color);
}

.payment-success-info {
  text-align: left;
}

.payment-success-info p {
  display: flex;
  justify-content: space-between;
  margin-bottom: 0.75rem;
  font-size: 0.875rem;
}

.payment-success-receipt {
  width: 100%;
  max-width: 400px;
  margin: 0 auto 1.5rem;
}

.payment-success-receipt h4 {
  font-size: 0.875rem;
  font-weight: 600;
  margin-bottom: 0.75rem;
  text-align: left;
}

.receipt-preview-success {
  border-radius: 0.375rem;
  border: 1px solid var(--border-color);
  overflow: hidden;
}

.receipt-preview-success img {
  width: 100%;
  height: auto;
  max-height: 200px;
  object-fit: contain;
}

.payment-success-actions {
  display: flex;
  gap: 1rem;
  margin-top: 1rem;
}

.print-receipt-button,
.close-success-button {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem 1.5rem;
  border-radius: 0.375rem;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;
}

.print-receipt-button {
  background-color: #f1f5f9;
  border: 1px solid var(--border-color);
  color: var(--text-primary);
}

.print-receipt-button:hover {
  background-color: #e2e8f0;
}

.close-success-button {
  background-color: var(--primary-color);
  color: white;
  border: none;
}

.close-success-button:hover {
  background-color: var(--primary-hover);
}

/* Page Styles */
.page-container {
  max-width: 900px;
  margin: 0 auto;
  padding: 1.5rem;
  background-color: var(--card-background);
  border-radius: 0.5rem;
  box-shadow: var(--shadow);
}

.page-header {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid var(--border-color);
}

.page-header h1 {
  font-size: 1.5rem;
  font-weight: 600;
}

.back-button {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 0.75rem;
  background-color: transparent;
  border: 1px solid var(--border-color);
  border-radius: 0.375rem;
  color: var(--text-secondary);
  font-size: 0.875rem;
  cursor: pointer;
  transition: background-color 0.2s, color 0.2s;
}

.back-button:hover {
  background-color: #f1f5f9;
  color: var(--text-primary);
}

/* Responsive Styles for Payment Modal */
@media (max-width: 768px) {
  .payment-methods-options {
    flex-direction: column;
  }

  .payment-method-option {
    width: 100%;
  }

  .payment-confirmation-details {
    grid-template-columns: 1fr;
  }

  .discount-type-selector {
    flex-direction: column;
  }

  .receipt-section {
    grid-column: span 1;
  }
}

@media print {
  .modal-overlay {
    position: static;
    background: none;
    padding: 0;
  }

  .payment-modal {
    box-shadow: none;
    max-width: 100%;
    max-height: none;
  }

  .close-button,
  .payment-actions,
  .payment-success-actions {
    display: none;
  }

  .payment-success {
    padding: 0;
  }
}

/* Adicionar estas regras de responsividade para o modal de pagamento */

/* Ajustes gerais para telas médias */
@media (max-width: 768px) {
  .payment-modal {
    max-width: 95%;
    max-height: 95vh;
  }

  .payment-methods-options {
    flex-direction: column;
  }

  .payment-method-option {
    width: 100%;
  }

  .payment-confirmation-details {
    grid-template-columns: 1fr;
  }

  .discount-type-selector {
    flex-direction: column;
    gap: 0.5rem;
  }

  .discount-type-option {
    width: 100%;
  }

  .payment-total {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.5rem;
  }

  .payment-actions {
    flex-direction: column;
    gap: 0.5rem;
  }

  .payment-actions button {
    width: 100%;
  }

  .payment-confirmation-actions {
    flex-direction: column;
    gap: 0.5rem;
  }

  .payment-confirmation-actions button {
    width: 100%;
  }

  .payment-success-actions {
    flex-direction: column;
    gap: 0.5rem;
  }

  .payment-success-actions button {
    width: 100%;
  }
}

/* Ajustes para telas pequenas */
@media (max-width: 480px) {
  .procedures-modal {
    max-width: 100%;
    max-height: 100vh;
    border-radius: 0;
  }

  .modal-overlay {
    padding: 0;
  }

  .payment-patient-info {
    flex-direction: column;
    gap: 0.5rem;
    align-items: flex-start;
  }

  .payment-procedure-item {
    flex-direction: column;
    align-items: flex-start;
  }

  .payment-procedure-checkbox {
    align-self: flex-start;
    margin-bottom: 0.5rem;
  }

  .payment-procedure-price {
    align-self: flex-end;
    margin-top: 0.5rem;
  }

  .payment-procedures-list {
    padding: 0.75rem;
  }

  .payment-summary {
    padding: 0.75rem;
  }

  .payment-discount-section {
    padding: 0.75rem;
  }

  .payment-methods {
    padding: 0.75rem;
  }

  .payment-actions {
    padding: 0.75rem;
  }

  .custom-total-input input {
    width: 100%;
  }
}

/* Ajustes específicos para a seção de desconto */
.payment-discount-section {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.discount-options {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

@media (min-width: 769px) {
  .discount-options {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 1rem;
  }
}

/* Melhorar a visualização da lista de procedimentos em telas pequenas */
@media (max-width: 600px) {
  .payment-procedure-meta {
    flex-direction: column;
    gap: 0.25rem;
  }

  .payment-procedure-item {
    padding: 0.5rem;
  }

  .payment-procedure-details h4 {
    font-size: 0.8rem;
  }

  .payment-procedure-meta {
    font-size: 0.7rem;
  }
}

/* Ajustes para o modo de edição do valor total */
@media (max-width: 600px) {
  .payment-total {
    flex-wrap: wrap;
  }

  .custom-total-input {
    width: 100%;
    margin-top: 0.5rem;
  }

  .custom-total-input input {
    width: 100%;
  }
}

/* Melhorar a visualização da confirmação em telas pequenas */
@media (max-width: 600px) {
  .payment-confirmation {
    padding: 0.75rem;
  }

  .payment-confirmation-header {
    padding: 0.75rem;
    flex-direction: column;
    text-align: center;
  }

  .payment-confirmation-section {
    padding: 0.75rem;
  }
}

/* Ajustes para a tela de sucesso em dispositivos pequenos */
@media (max-width: 600px) {
  .payment-success {
    padding: 1rem;
  }

  .payment-success-icon {
    width: 60px;
    height: 60px;
  }

  .payment-success h3 {
    font-size: 1.1rem;
  }

  .payment-success-details {
    padding: 1rem;
  }
}

/* Ajustes para o modal de procedimentos agendados */
.scheduled-procedures-modal {
  max-width: 800px;
  display: flex;
  flex-direction: column;
  height: 90vh;
}

.scheduled-procedures-list {
  padding: 1rem 1.5rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

/* Garantir que o conteúdo do modal tenha rolagem */
.modal-content-scrollable {
  flex: 1 1;
  overflow-y: auto;
  padding-bottom: 1rem;
}

/* Garantir que o rodapé fique fixo */
.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 0.75rem;
  padding: 1rem 1.5rem;
  border-top: 1px solid var(--border-color);
  background-color: var(--card-background);
  flex-shrink: 0;
}

/* Ajustes para o modal de agendamento */
.scheduling-page {
  max-height: 90vh;
  overflow-y: auto;
}

.form-actions {
  position: sticky;
  bottom: 0;
  background-color: var(--card-background);
  padding: 1rem 0;
  margin-top: 1rem;
  border-top: 1px solid var(--border-color);
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  z-index: 10;
}

/* Ajustes responsivos para telas pequenas */
@media (max-width: 768px) {
  .scheduled-procedure-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.5rem;
  }

  .scheduled-date-time {
    flex-direction: column;
    gap: 0.25rem;
  }

  .scheduled-procedure-actions {
    flex-wrap: wrap;
    gap: 0.5rem;
  }

  .scheduled-procedure-actions button {
    flex: 1 0 auto;
    min-width: 120px;
  }
}

@media (max-width: 480px) {
  .scheduled-procedures-list {
    padding: 0.75rem;
  }

  .scheduled-procedure-card {
    padding: 0;
  }

  .scheduled-procedure-content {
    padding: 0.75rem;
  }

  .scheduled-procedures li {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.25rem;
  }

  .scheduled-procedure-actions {
    flex-direction: column;
  }

  .scheduled-procedure-actions button {
    width: 100%;
  }
}

/* Ajustes para a página de confirmação */
.confirmation-page {
  max-height: 90vh;
  overflow-y: auto;
}

.confirmation-actions {
  position: sticky;
  bottom: 0;
  background-color: var(--card-background);
  padding: 1rem 0;
  margin-top: 1rem;
  border-top: 1px solid var(--border-color);
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  z-index: 10;
}

/* Ajustes responsivos para a página de confirmação */
@media (max-width: 768px) {
  .confirmation-details {
    grid-template-columns: 1fr;
  }

  .confirmation-actions {
    flex-direction: column;
    gap: 0.75rem;
  }

  .confirmation-actions button {
    width: 100%;
  }
}

/* Ajustes para garantir que os botões sejam sempre visíveis em telas pequenas */
@media (max-height: 700px) {
  .form-actions,
  .confirmation-actions,
  .modal-footer {
    position: sticky;
    bottom: 0;
    background-color: var(--card-background);
    padding: 0.75rem;
    margin-top: 0.75rem;
    z-index: 10;
  }
}

@media (max-height: 800px) {
  .button-cashier {
  }
  .app-container {
    height: 80vh;
    overflow-y: auto;
    margin: 0 auto;
    padding: 1rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/views/newPosConsult/css/PosConsultPageHome.css"],"names":[],"mappings":"AAAA;EACE,wBAAwB;EACxB,wBAAwB;EACxB,0BAA0B;EAC1B,2BAA2B;EAC3B,0BAA0B;EAC1B,uBAAuB;EACvB,uBAAuB;EACvB,yBAAyB;EACzB,sBAAsB;EACtB,wBAAwB;EACxB,wBAAwB;EACxB;sCACoC;AACtC;;AAEA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;EACtB;wEACsE;AACxE;;AAEA;EACE,yCAAyC;EACzC,0BAA0B;AAC5B;;AAEA,2BAA2B;AAC3B;EACE,kCAAkC;AACpC;AACA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,oBAAoB;EACpB,sCAAsC;EACtC,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,qCAAqC;EACrC,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,aAAa;AACf;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,wCAAwC;EACxC,uBAAuB;EACvB,qBAAqB;EACrB,qCAAqC;AACvC;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,0BAA0B;EAC1B,uBAAuB;AACzB;;AAEA;;;EAGE,6BAA6B;AAC/B;;AAEA,qBAAqB;AACrB;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,oCAAoC;EACpC,qBAAqB;EACrB,qCAAqC;EACrC,eAAe;EACf,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,QAAQ;EACR,2BAA2B;AAC7B;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,wCAAwC;EACxC,qBAAqB;EACrB,aAAa;EACb,yBAAyB;EACzB,2CAA2C;EAC3C,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B;sCACoC;AACtC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,4BAA4B;EAC5B,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,uBAAuB;EACvB,sCAAsC;EACtC,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,uBAAuB;EACvB,sCAAsC;EACtC,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,qCAAqC;EACrC,kBAAkB;EAClB,6BAA6B;EAC7B,eAAe;EACf,6CAA6C;AAC/C;;AAEA;EACE,qCAAqC;EACrC,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,uBAAuB;EACvB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,4BAA4B;EAC5B,kBAAkB;EAClB,SAAS;AACX;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,wCAAwC;EACxC,qBAAqB;EACrB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB;wCACsC;AACxC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,oBAAoB;EACpB,4CAA4C;EAC5C,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,4BAA4B;EAC5B,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,sBAAsB;EACtB,6CAA6C;AAC/C;;AAEA;EACE,qCAAqC;EACrC,0BAA0B;AAC5B;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;EAClB,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,mCAAmC;EACnC,uBAAuB;EACvB,qCAAqC;EACrC,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,QAAQ;EACR,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,uBAAuB;EACvB,qCAAqC;EACrC,mBAAmB;EACnB,aAAa;EACb,wCAAwC;AAC1C;;AAEA;EACE,iBAAiB;EACjB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,qCAAqC;EACrC,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,oDAAoD;AACtD;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,kCAAkC;EAClC,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,uBAAuB;EACvB,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,qCAAqC;EACrC,eAAe;EACf,oDAAoD;AACtD;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;EAClC,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,oBAAoB;EACpB,yCAAyC;EACzC,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,4BAA4B;EAC5B,uBAAuB;EACvB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,6BAA6B;EAC7B,qCAAqC;EACrC,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,4BAA4B;EAC5B,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,sCAAsC;EACtC,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,+CAA+C;AACjD;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,sCAAsC;AACtC;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,uBAAuB;EACvB,qBAAqB;EACrB,qCAAqC;EACrC,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,qBAAqB;EACrB,yBAAyB;EACzB,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,4BAA4B;EAC5B,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,sBAAsB;EACtB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,YAAY;EACZ,qBAAqB;EACrB,yCAAyC;EACzC,yBAAyB;AAC3B;;AAEA;;;;EAIE,uBAAuB;EACvB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iCAAiC;EACjC,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,qCAAqC;EACrC,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,SAAS;EACT,4BAA4B;AAC9B;;AAEA;EACE,uBAAuB;EACvB,sCAAsC;EACtC,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;EACE,sCAAsC;AACxC;;AAEA,yBAAyB;AACzB;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,oBAAoB;EACpB,yBAAyB;EACzB,4CAA4C;AAC9C;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,mBAAmB;AACrB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,4CAA4C;AAC9C;;AAEA;EACE,sBAAsB;EACtB,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,0CAA0C;AAC5C;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA;EACE,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,qCAAqC;EACrC,eAAe;EACf,oDAAoD;AACtD;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;EAClC,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,yCAAyC;EACzC,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,uBAAuB;EACvB,uBAAuB;EACvB,qCAAqC;EACrC,kBAAkB;EAClB,eAAe;EACf,oDAAoD;AACtD;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;EAClC,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,QAAQ;EACR,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,kCAAkC;EAClC,uBAAuB;EACvB,qCAAqC;EACrC,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,4BAA4B;EAC5B,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,uBAAuB;EACvB,qCAAqC;EACrC,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,4BAA4B;EAC5B,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,sBAAsB;EACtB,6CAA6C;AAC/C;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;;EAEE,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,sBAAsB;EACtB,6CAA6C;AAC/C;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,QAAQ;EACR,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,kCAAkC;EAClC,uBAAuB;EACvB,sCAAsC;EACtC,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,qBAAqB;EACrB,uBAAuB;EACvB,qCAAqC;EACrC,mBAAmB;EACnB,eAAe;EACf,oDAAoD;AACtD;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;EAClC,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;EACpB,0CAA0C;AAC5C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,uBAAuB;EACvB,qCAAqC;EACrC,mBAAmB;EACnB,aAAa;EACb,wCAAwC;AAC1C;;AAEA,yCAAyC;AACzC;EACE,kBAAkB;EAClB,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,sCAAsC;EACtC,uBAAuB;EACvB,4BAA4B;EAC5B,mBAAmB;EACnB,eAAe;EACf,oDAAoD;AACtD;;AAEA;EACE,yBAAyB;EACzB,kCAAkC;EAClC,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;EAChB,yBAAyB;EACzB,qCAAqC;EACrC,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,gBAAgB;EAChB,qCAAqC;EACrC,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,0BAA0B;EAC1B,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,uBAAuB;EACvB,sCAAsC;EACtC,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,+CAA+C;AACjD;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,gCAAgC;AAChC;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,yBAAyB;EACzB,qBAAqB;EACrB,qBAAqB;EACrB,2CAA2C;AAC7C;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,aAAa;EACb,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;EACtB,sBAAsB;EACtB,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,uBAAuB;EACvB,6BAA6B;EAC7B,qCAAqC;EACrC,uBAAuB;EACvB,4BAA4B;EAC5B,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,uBAAuB;EACvB,sCAAsC;EACtC,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,4BAA4B;EAC5B,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,qBAAqB;EACrB,qCAAqC;AACvC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,uBAAuB;EACvB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;EACzB,qCAAqC;EACrC,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sCAAsC;EACtC,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,sCAAsC;AACxC;;AAEA,gBAAgB;AAChB;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,wCAAwC;EACxC,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,oBAAoB;EACpB,4CAA4C;AAC9C;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,uBAAuB;EACvB,6BAA6B;EAC7B,qCAAqC;EACrC,uBAAuB;EACvB,4BAA4B;EAC5B,mBAAmB;EACnB,eAAe;EACf,6CAA6C;AAC/C;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA,wCAAwC;AACxC;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,gBAAgB;IAChB,UAAU;EACZ;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,gBAAgB;EAClB;;EAEA;;;IAGE,aAAa;EACf;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA,uEAAuE;;AAEvE,qCAAqC;AACrC;EACE;IACE,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,WAAW;EACb;;EAEA;IACE,WAAW;EACb;AACF;;AAEA,gCAAgC;AAChC;EACE;IACE,eAAe;IACf,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,sBAAsB;IACtB,WAAW;IACX,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;IACtB,qBAAqB;EACvB;;EAEA;IACE,oBAAoB;IACpB,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,WAAW;EACb;AACF;;AAEA,iDAAiD;AACjD;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE;IACE,aAAa;IACb,8BAA8B;IAC9B,SAAS;EACX;AACF;;AAEA,wEAAwE;AACxE;EACE;IACE,sBAAsB;IACtB,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA,iDAAiD;AACjD;EACE;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,WAAW;EACb;AACF;;AAEA,6DAA6D;AAC7D;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA,4DAA4D;AAC5D;EACE;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA,oDAAoD;AACpD;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,mDAAmD;AACnD;EACE,SAAO;EACP,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA,qCAAqC;AACrC;EACE,aAAa;EACb,yBAAyB;EACzB,YAAY;EACZ,oBAAoB;EACpB,yCAAyC;EACzC,wCAAwC;EACxC,cAAc;AAChB;;AAEA,wCAAwC;AACxC;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,wCAAwC;EACxC,eAAe;EACf,gBAAgB;EAChB,yCAAyC;EACzC,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,WAAW;AACb;;AAEA,4CAA4C;AAC5C;EACE;IACE,sBAAsB;IACtB,uBAAuB;IACvB,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,YAAY;EACd;;EAEA;IACE,eAAe;IACf,WAAW;EACb;;EAEA;IACE,cAAc;IACd,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,YAAY;EACd;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;AACF;;AAEA,yCAAyC;AACzC;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,wCAAwC;EACxC,eAAe;EACf,gBAAgB;EAChB,yCAAyC;EACzC,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,WAAW;AACb;;AAEA,qDAAqD;AACrD;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,YAAY;EACd;;EAEA;IACE,WAAW;EACb;AACF;;AAEA,gFAAgF;AAChF;EACE;;;IAGE,gBAAgB;IAChB,SAAS;IACT,wCAAwC;IACxC,gBAAgB;IAChB,mBAAmB;IACnB,WAAW;EACb;AACF;;AAEA;EACE;EACA;EACA;IACE,YAAY;IACZ,gBAAgB;IAChB,cAAc;IACd,aAAa;EACf;AACF","sourcesContent":[":root {\n  --primary-color: #2563eb;\n  --primary-hover: #1d4ed8;\n  --secondary-color: #64748b;\n  --background-color: #f8fafc;\n  --card-background: #ffffff;\n  --border-color: #e2e8f0;\n  --text-primary: #1e293b;\n  --text-secondary: #64748b;\n  --error-color: #ef4444;\n  --success-color: #10b981;\n  --warning-color: #f59e0b;\n  --shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1),\n    0 2px 4px -1px rgba(0, 0, 0, 0.06);\n}\n\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n  font-family: \"Inter\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto,\n    Oxygen, Ubuntu, Cantarell, \"Open Sans\", \"Helvetica Neue\", sans-serif;\n}\n\nbody {\n  background-color: var(--background-color);\n  color: var(--text-primary);\n}\n\n/* PosConsultPageHome.css */\n.spin {\n  animation: spin 1s linear infinite;\n}\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n.button-cashier {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.5rem 1rem;\n  background-color: var(--primary-color);\n  color: white;\n  border: none;\n  border-radius: 0.375rem;\n  font-size: 0.875rem;\n  font-weight: 500;\n  border: 1px solid var(--border-color);\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.button-cashier:hover {\n  background-color: var(--primary-hover);\n}\n\n.app-container {\n  height: 85vh;\n  overflow-y: auto;\n  margin: 0 auto;\n  padding: 1rem;\n}\n\n/* Header Styles */\n.app-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 2rem;\n  flex-wrap: wrap;\n  gap: 1rem;\n}\n\n.logo-container {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n}\n\n.logo-icon {\n  color: var(--primary-color);\n}\n\n.app-header h1 {\n  font-size: 1.75rem;\n  font-weight: 600;\n  color: var(--text-primary);\n}\n\n.header-controls {\n  display: flex;\n  gap: 1.5rem;\n  align-items: center;\n  flex-wrap: wrap;\n}\n\n.date-picker {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  background-color: var(--card-background);\n  padding: 0.5rem 0.75rem;\n  border-radius: 0.5rem;\n  border: 1px solid var(--border-color);\n}\n\n.date-picker input {\n  border: none;\n  outline: none;\n  font-size: 0.875rem;\n  color: var(--text-primary);\n  background: transparent;\n}\n\n.date-icon,\n.filter-icon,\n.search-icon {\n  color: var(--secondary-color);\n}\n\n/* Search Container */\n.search-container {\n  position: relative;\n  margin-bottom: 1.5rem;\n}\n\n.search-container input {\n  width: 100%;\n  padding: 0.75rem 1rem 0.75rem 2.5rem;\n  border-radius: 0.5rem;\n  border: 1px solid var(--border-color);\n  font-size: 1rem;\n  outline: none;\n  transition: border-color 0.2s;\n}\n\n.search-container input:focus {\n  border-color: var(--primary-color);\n}\n\n.search-icon {\n  position: absolute;\n  left: 0.75rem;\n  top: 50%;\n  transform: translateY(-50%);\n}\n\n/* Patient Card Styles */\n.patients-list {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.patient-card {\n  display: flex;\n  background-color: var(--card-background);\n  border-radius: 0.5rem;\n  padding: 1rem;\n  box-shadow: var(--shadow);\n  transition: transform 0.2s, box-shadow 0.2s;\n  gap: 1rem;\n  align-items: center;\n}\n\n.patient-card:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1),\n    0 4px 6px -2px rgba(0, 0, 0, 0.05);\n}\n\n.patient-avatar {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 48px;\n  height: 48px;\n  background-color: #e2e8f0;\n  border-radius: 50%;\n  color: var(--secondary-color);\n  flex-shrink: 0;\n}\n\n.patient-info {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  margin-left: 3rem;\n}\n\n.patient-main-info {\n  display: flex;\n  justify-content: space-between;\n  gap: 1rem;\n  flex-wrap: wrap;\n}\n\n.patient-name-container {\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n}\n\n.patient-name {\n  font-size: 1rem;\n  font-weight: 600;\n  color: var(--text-primary);\n}\n\n.patient-cpf {\n  font-size: 0.875rem;\n  color: var(--text-secondary);\n}\n\n.btn-whatsapp{\n  background: #25d366;\n  width: 48px;\n  height: 48px;\n}\n\n.btn-whatsapp:hover{\n  background: #128c7e;\n  cursor: pointer;\n}\n\n.patient-exam-info {\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n  text-align: right;\n}\n\n.exam-type {\n  font-size: 0.875rem;\n  font-weight: 500;\n  color: var(--text-primary);\n}\n\n.exam-code {\n  font-size: 0.75rem;\n  color: var(--text-secondary);\n}\n\n.patient-secondary-info {\n  display: flex;\n  justify-content: space-between;\n  color: var(--text-secondary);\n  font-size: 0.75rem;\n  margin-top: 0.25rem;\n}\n\n.patient-actions {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n}\n\n.budget-button {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.5rem 0.75rem;\n  background-color: deepskyblue;\n  color: white;\n  border: none;\n  border-radius: 0.375rem;\n  font-size: 0.875rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.budget-button:hover {\n  background-color: var(--primary-hover);\n}\n\n.budget-button:disabled {\n  background-color: #d6d6d6; \n  color: #a1a1a1;\n  cursor: not-allowed;\n  opacity: 0.7; \n}\n\n.procedure-button {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.5rem 0.75rem;\n  background-color: var(--primary-color);\n  color: white;\n  border: none;\n  border-radius: 0.375rem;\n  font-size: 0.875rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.procedure-button:hover {\n  background-color: var(--primary-hover);\n}\n\n.scheduled-button {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.5rem 0.75rem;\n  background-color: var(--success-color);\n  color: white;\n  border: none;\n  border-radius: 0.375rem;\n  font-size: 0.875rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.scheduled-button:hover {\n  background-color: #059669;\n}\n\n.details-button {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 36px;\n  height: 36px;\n  background-color: transparent;\n  border: 1px solid var(--border-color);\n  border-radius: 50%;\n  color: var(--secondary-color);\n  cursor: pointer;\n  transition: background-color 0.2s, color 0.2s;\n}\n\n.details-button:hover {\n  background-color: var(--border-color);\n  color: var(--text-primary);\n}\n\n.payment-card-button {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.5rem 0.75rem;\n  background-color: #f59e0b;\n  color: white;\n  border: none;\n  border-radius: 0.375rem;\n  font-size: 0.875rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.payment-card-button:hover {\n  background-color: #d97706;\n}\n\n.no-results {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 3rem;\n  color: var(--text-secondary);\n  text-align: center;\n  gap: 1rem;\n}\n\n/* Modal Styles */\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 2000;\n  padding: 1rem;\n}\n\n.procedures-modal {\n  background-color: var(--card-background);\n  border-radius: 0.5rem;\n  width: 100%;\n  max-width: 700px;\n  max-height: 90vh;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1),\n    0 10px 10px -5px rgba(0, 0, 0, 0.04);\n}\n\n.modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 1rem 1.5rem;\n  border-bottom: 1px solid var(--border-color);\n  flex-shrink: 0;\n}\n\n.modal-header h2 {\n  font-size: 1.25rem;\n  font-weight: 600;\n}\n\n.close-button {\n  background: transparent;\n  border: none;\n  color: var(--text-secondary);\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0.25rem;\n  border-radius: 0.25rem;\n  transition: background-color 0.2s, color 0.2s;\n}\n\n.close-button:hover {\n  background-color: var(--border-color);\n  color: var(--text-primary);\n}\n\n.modal-content-scrollable {\n  flex: 1;\n  overflow-y: auto;\n  padding-bottom: 1rem;\n}\n\n.modal-search {\n  padding: 1rem 1.5rem;\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  border-bottom: 1px solid var(--border-color);\n}\n\n.search-input {\n  position: relative;\n  flex: 1;\n  min-width: 200px;\n}\n\n.search-input input {\n  width: 100%;\n  padding: 0.5rem 0.75rem 0.5rem 2rem;\n  border-radius: 0.375rem;\n  border: 1px solid var(--border-color);\n  font-size: 0.875rem;\n  outline: none;\n}\n\n.search-input svg {\n  position: absolute;\n  left: 0.5rem;\n  top: 50%;\n  transform: translateY(-50%);\n  color: var(--text-secondary);\n}\n\n.sector-filter {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  font-size: 0.875rem;\n}\n\n.sector-filter select {\n  padding: 0.5rem;\n  border-radius: 0.375rem;\n  border: 1px solid var(--border-color);\n  font-size: 0.875rem;\n  outline: none;\n  background-color: var(--card-background);\n}\n\n.select-all-container {\n  padding: 0.5rem 0;\n  border-top: 1px dashed var(--border-color);\n}\n\n.select-all-label {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  font-size: 0.875rem;\n  cursor: pointer;\n}\n\n.sector-buttons {\n  padding-top: 0.5rem;\n  border-top: 1px dashed var(--border-color);\n}\n\n.sector-buttons-title {\n  font-size: 0.875rem;\n  margin-bottom: 0.5rem;\n  color: var(--text-secondary);\n}\n\n.sector-buttons-container {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n}\n\n.sector-select-button {\n  padding: 0.375rem 0.75rem;\n  background-color: #f1f5f9;\n  border: 1px solid var(--border-color);\n  border-radius: 0.375rem;\n  font-size: 0.75rem;\n  cursor: pointer;\n  transition: background-color 0.2s, border-color 0.2s;\n}\n\n.sector-select-button:hover {\n  background-color: #e2e8f0;\n  border-color: #cbd5e1;\n}\n\n.sector-select-button.selected {\n  background-color: #eff6ff;\n  border-color: var(--primary-color);\n  color: var(--primary-color);\n}\n\n.error-message {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.75rem 1.5rem;\n  background-color: #fee2e2;\n  color: var(--error-color);\n  font-size: 0.875rem;\n}\n\n.procedures-list {\n  flex: 1;\n  overflow-y: auto;\n  padding: 1rem 1.5rem;\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n\n.procedure-item {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.75rem;\n  padding: 0.75rem;\n  border-radius: 0.375rem;\n  border: 1px solid var(--border-color);\n  cursor: pointer;\n  transition: background-color 0.2s, border-color 0.2s;\n}\n\n.procedure-item:hover {\n  background-color: #f1f5f9;\n}\n\n.procedure-item.selected {\n  border-color: var(--primary-color);\n  background-color: #eff6ff;\n}\n\n.procedure-checkbox {\n  padding-top: 0.25rem;\n}\n\n.procedure-details {\n  flex: 1;\n}\n\n.procedure-details h4 {\n  font-size: 0.875rem;\n  font-weight: 600;\n  margin-bottom: 0.25rem;\n}\n\n.procedure-meta {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 1rem;\n  font-size: 0.75rem;\n  color: var(--text-secondary);\n}\n\n.no-procedures {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 2rem;\n  color: var(--text-secondary);\n}\n\n.modal-footer {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n  padding: 1rem 1.5rem;\n  border-top: 1px solid var(--border-color);\n  background-color: var(--card-background);\n  flex-shrink: 0;\n}\n\n.available-doctors {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  font-size: 0.875rem;\n  color: var(--text-secondary);\n  padding-bottom: 0.75rem;\n  border-bottom: 1px dashed var(--border-color);\n}\n\n.modal-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 1rem;\n}\n\n.cancel-button {\n  padding: 0.5rem 1rem;\n  background-color: transparent;\n  border: 1px solid var(--border-color);\n  border-radius: 0.375rem;\n  font-size: 0.875rem;\n  font-weight: 500;\n  color: var(--text-secondary);\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.cancel-button:hover {\n  background-color: #f1f5f9;\n}\n\n.schedule-button {\n  padding: 0.5rem 1rem;\n  background-color: var(--primary-color);\n  color: white;\n  border: none;\n  border-radius: 0.375rem;\n  font-size: 0.875rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background-color 0.2s, opacity 0.2s;\n}\n\n.schedule-button:hover:not(:disabled) {\n  background-color: var(--primary-hover);\n}\n\n.schedule-button:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n/* Scheduled Procedures Modal Styles */\n.scheduled-procedures-modal {\n  max-width: 800px;\n  display: flex;\n  flex-direction: column;\n  height: 90vh;\n}\n\n.scheduled-procedures-list {\n  padding: 1rem 1.5rem;\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.scheduled-procedure-card {\n  background-color: white;\n  border-radius: 0.5rem;\n  border: 1px solid var(--border-color);\n  overflow: hidden;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n}\n\n.scheduled-procedure-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0.75rem 1rem;\n  background-color: #f8fafc;\n  border-bottom: 1px solid var(--border-color);\n}\n\n.scheduled-date-time {\n  display: flex;\n  gap: 1rem;\n}\n\n.scheduled-date,\n.scheduled-time {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  font-size: 0.875rem;\n}\n\n.scheduled-status {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  font-size: 0.875rem;\n  font-weight: 500;\n}\n\n.status-icon.status-confirmed {\n  color: var(--primary-color);\n}\n\n.status-icon.status-completed {\n  color: var(--success-color);\n}\n\n.status-icon.status-canceled {\n  color: var(--error-color);\n}\n\n.status-icon.status-pending {\n  color: var(--warning-color);\n}\n\n.scheduled-procedure-content {\n  padding: 1rem;\n}\n\n.scheduled-doctor {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  margin-bottom: 1rem;\n  font-size: 0.875rem;\n  font-weight: 500;\n}\n\n.doctor-specialty {\n  font-weight: normal;\n  color: var(--text-secondary);\n  margin-left: 0.25rem;\n}\n\n.scheduled-procedures {\n  list-style: none;\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  margin: 0.5rem 0 1rem;\n}\n\n.scheduled-procedures li {\n  display: flex;\n  justify-content: space-between;\n  font-size: 0.875rem;\n  padding-bottom: 0.5rem;\n  border-bottom: 1px dashed var(--border-color);\n}\n\n.scheduled-total {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding-top: 0.5rem;\n  font-weight: 500;\n  font-size: 0.875rem;\n}\n\n.total-price {\n  color: var(--primary-color);\n  font-size: 1rem;\n}\n\n.scheduled-comments {\n  margin-top: 1rem;\n  padding: 0.75rem;\n  background-color: #f8fafc;\n  border-radius: 0.375rem;\n  font-size: 0.875rem;\n}\n\n.scheduled-comments h4 {\n  margin-bottom: 0.5rem;\n  font-size: 0.875rem;\n  color: var(--text-secondary);\n}\n\n.scheduled-procedure-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 0.75rem;\n  padding: 0.75rem 1rem;\n  border-top: 1px solid var(--border-color);\n  background-color: #f8fafc;\n}\n\n.reschedule-button,\n.cancel-appointment-button,\n.view-results-button,\n.payment-button {\n  padding: 0.5rem 0.75rem;\n  border-radius: 0.375rem;\n  font-size: 0.75rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background-color 0.2s;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.reschedule-button {\n  background-color: #f8fafc;\n  border: 1px solid var(--border-color);\n  color: var(--text-secondary);\n}\n\n.reschedule-button:hover {\n  background-color: #f1f5f9;\n}\n\n.cancel-appointment-button {\n  background-color: #fee2e2;\n  border: 1px solid #fecaca;\n  color: #b91c1c;\n}\n\n.cancel-appointment-button:hover {\n  background-color: #fecaca;\n}\n\n.view-results-button {\n  background-color: #ecfdf5;\n  border: 1px solid #d1fae5;\n  color: #047857;\n}\n\n.view-results-button:hover {\n  background-color: #d1fae5;\n}\n\n.payment-button {\n  background-color: #fffbeb;\n  border: 1px solid #fef3c7;\n  color: #b45309;\n}\n\n.payment-button:hover {\n  background-color: #fef3c7;\n}\n\n.no-scheduled-procedures {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 3rem 1rem;\n  text-align: center;\n  gap: 1rem;\n  color: var(--text-secondary);\n}\n\n.schedule-new-button {\n  padding: 0.75rem 1.5rem;\n  background-color: var(--primary-color);\n  color: white;\n  border: none;\n  border-radius: 0.375rem;\n  font-size: 0.875rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background-color 0.2s;\n  margin-top: 1rem;\n}\n\n.schedule-new-button:hover {\n  background-color: var(--primary-hover);\n}\n\n/* Payment Modal Styles */\n.payment-modal {\n  max-width: 800px;\n  display: flex;\n  flex-direction: column;\n  height: 90vh;\n}\n\n.payment-patient-info {\n  display: flex;\n  justify-content: space-between;\n  padding: 1rem 1.5rem;\n  background-color: #f8fafc;\n  border-bottom: 1px solid var(--border-color);\n}\n\n.payment-patient-name,\n.payment-date {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  font-size: 0.875rem;\n}\n\n.payment-patient-name strong,\n.payment-date strong {\n  font-weight: 600;\n}\n\n.payment-search-container {\n  padding: 1rem 1.5rem;\n  border-bottom: 1px solid var(--border-color);\n}\n\n.payment-selection-options {\n  padding: 0.5rem 1.5rem;\n  border-bottom: 1px solid var(--border-color);\n}\n\n.select-by-sector {\n  margin-top: 0.75rem;\n  padding-top: 0.75rem;\n  border-top: 1px dashed var(--border-color);\n}\n\n.select-by-sector-title {\n  font-size: 0.875rem;\n  margin-bottom: 0.5rem;\n  color: var(--text-secondary);\n}\n\n.payment-procedures-list {\n  padding: 1rem 1.5rem;\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n  max-height: 300px;\n  overflow-y: auto;\n}\n\n.payment-procedure-item {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  padding: 0.75rem;\n  border-radius: 0.375rem;\n  border: 1px solid var(--border-color);\n  cursor: pointer;\n  transition: background-color 0.2s, border-color 0.2s;\n}\n\n.payment-procedure-item:hover {\n  background-color: #f1f5f9;\n}\n\n.payment-procedure-item.selected {\n  border-color: var(--primary-color);\n  background-color: #eff6ff;\n}\n\n.payment-procedure-checkbox {\n  display: flex;\n  align-items: center;\n}\n\n.payment-procedure-details {\n  flex: 1;\n}\n\n.payment-procedure-details h4 {\n  font-size: 0.875rem;\n  font-weight: 600;\n  margin-bottom: 0.25rem;\n}\n\n.payment-procedure-meta {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 1rem;\n  font-size: 0.75rem;\n  color: var(--text-secondary);\n}\n\n.payment-procedure-price {\n  font-weight: 600;\n  color: var(--primary-color);\n  font-size: 0.875rem;\n}\n\n.payment-summary {\n  padding: 1rem 1.5rem;\n  border-top: 1px solid var(--border-color);\n  border-bottom: 1px solid var(--border-color);\n}\n\n.payment-subtotal {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  font-size: 0.875rem;\n  font-weight: 500;\n  margin-bottom: 1rem;\n}\n\n.payment-subtotal-value {\n  font-weight: 600;\n}\n\n.payment-discount-section {\n  background-color: #f8fafc;\n  border-radius: 0.5rem;\n  padding: 1rem;\n  margin-bottom: 1rem;\n}\n\n.payment-discount-section h4 {\n  font-size: 0.875rem;\n  font-weight: 600;\n  margin-bottom: 0.75rem;\n  color: var(--text-secondary);\n}\n\n.discount-options {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n\n.discount-type-selector {\n  display: flex;\n  gap: 1rem;\n}\n\n.discount-type-option {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.5rem 0.75rem;\n  border-radius: 0.375rem;\n  border: 1px solid var(--border-color);\n  font-size: 0.75rem;\n  cursor: pointer;\n  transition: background-color 0.2s, border-color 0.2s;\n}\n\n.discount-type-option:hover {\n  background-color: #f1f5f9;\n}\n\n.discount-type-option.selected {\n  border-color: var(--primary-color);\n  background-color: #eff6ff;\n}\n\n.discount-type-option input {\n  position: absolute;\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n\n.discount-type-option svg {\n  color: var(--primary-color);\n}\n\n.discount-value-input {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.discount-value-input label {\n  font-size: 0.75rem;\n  color: var(--text-secondary);\n}\n\n.discount-input-wrapper {\n  position: relative;\n}\n\n.discount-input-icon {\n  position: absolute;\n  left: 0.5rem;\n  top: 50%;\n  transform: translateY(-50%);\n  color: var(--text-secondary);\n}\n\n.discount-value-input input {\n  width: 100%;\n  padding: 0.5rem 0.5rem 0.5rem 2rem;\n  border-radius: 0.375rem;\n  border: 1px solid var(--border-color);\n  font-size: 0.875rem;\n  outline: none;\n}\n\n.discount-reason {\n  margin-top: 0.75rem;\n}\n\n.discount-reason label {\n  display: block;\n  font-size: 0.75rem;\n  color: var(--text-secondary);\n  margin-bottom: 0.5rem;\n}\n\n.discount-reason input {\n  width: 100%;\n  padding: 0.5rem 0.75rem;\n  border-radius: 0.375rem;\n  border: 1px solid var(--border-color);\n  font-size: 0.875rem;\n  outline: none;\n}\n\n.discount-summary {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-top: 0.75rem;\n  padding-top: 0.75rem;\n  border-top: 1px dashed var(--border-color);\n  font-size: 0.875rem;\n}\n\n.discount-value {\n  font-weight: 600;\n  color: var(--error-color);\n}\n\n.payment-total {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  font-size: 0.875rem;\n  font-weight: 500;\n  padding-top: 0.75rem;\n  margin-top: 0.5rem;\n  border-top: 1px solid var(--border-color);\n}\n\n.payment-total-label {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.edit-total-button {\n  background: transparent;\n  border: none;\n  color: var(--text-secondary);\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0.25rem;\n  border-radius: 0.25rem;\n  transition: background-color 0.2s, color 0.2s;\n}\n\n.edit-total-button:hover {\n  background-color: #f1f5f9;\n  color: var(--primary-color);\n}\n\n.edit-total-actions {\n  display: flex;\n  gap: 0.25rem;\n}\n\n.save-total-button,\n.cancel-edit-button {\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0.25rem;\n  border-radius: 0.25rem;\n  transition: background-color 0.2s, color 0.2s;\n}\n\n.save-total-button {\n  color: var(--success-color);\n}\n\n.save-total-button:hover {\n  background-color: #ecfdf5;\n}\n\n.cancel-edit-button {\n  color: var(--error-color);\n}\n\n.cancel-edit-button:hover {\n  background-color: #fee2e2;\n}\n\n.custom-total-input {\n  position: relative;\n}\n\n.custom-total-icon {\n  position: absolute;\n  left: 0.5rem;\n  top: 50%;\n  transform: translateY(-50%);\n  color: var(--text-secondary);\n}\n\n.custom-total-input input {\n  padding: 0.5rem 0.5rem 0.5rem 2rem;\n  border-radius: 0.375rem;\n  border: 1px solid var(--primary-color);\n  font-size: 0.875rem;\n  outline: none;\n  width: 150px;\n  background-color: #eff6ff;\n}\n\n.payment-total-value {\n  font-size: 1.125rem;\n  color: var(--primary-color);\n  font-weight: 600;\n}\n\n.payment-methods {\n  padding: 1rem 1.5rem;\n  border-bottom: 1px solid var(--border-color);\n}\n\n.payment-methods h3 {\n  font-size: 0.875rem;\n  font-weight: 600;\n  margin-bottom: 0.75rem;\n}\n\n.payment-methods-options {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.75rem;\n  margin-bottom: 1rem;\n}\n\n.payment-method-option {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.75rem 1rem;\n  border-radius: 0.375rem;\n  border: 1px solid var(--border-color);\n  font-size: 0.875rem;\n  cursor: pointer;\n  transition: background-color 0.2s, border-color 0.2s;\n}\n\n.payment-method-option:hover {\n  background-color: #f1f5f9;\n}\n\n.payment-method-option.selected {\n  border-color: var(--primary-color);\n  background-color: #eff6ff;\n}\n\n.payment-method-option input {\n  position: absolute;\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n\n.payment-method-option svg {\n  color: var(--primary-color);\n}\n\n.payment-installments {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  margin-top: 0.75rem;\n  padding-top: 0.75rem;\n  border-top: 1px dashed var(--border-color);\n}\n\n.payment-installments label {\n  font-size: 0.875rem;\n}\n\n.payment-installments select {\n  padding: 0.5rem;\n  border-radius: 0.375rem;\n  border: 1px solid var(--border-color);\n  font-size: 0.875rem;\n  outline: none;\n  background-color: var(--card-background);\n}\n\n/* Estilos para o upload de comprovante */\n.payment-receipt-upload {\n  margin-top: 1.5rem;\n  padding-top: 1.5rem;\n  border-top: 1px dashed var(--border-color);\n}\n\n.payment-receipt-upload h4 {\n  font-size: 0.875rem;\n  font-weight: 600;\n  margin-bottom: 0.5rem;\n  color: var(--text-secondary);\n}\n\n.upload-description {\n  font-size: 0.75rem;\n  color: var(--text-secondary);\n  margin-bottom: 1rem;\n}\n\n.file-input-hidden {\n  display: none;\n}\n\n.upload-button {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n  width: 100%;\n  padding: 0.75rem;\n  background-color: #f8fafc;\n  border: 1px dashed var(--border-color);\n  border-radius: 0.375rem;\n  color: var(--text-secondary);\n  font-size: 0.875rem;\n  cursor: pointer;\n  transition: background-color 0.2s, border-color 0.2s;\n}\n\n.upload-button:hover {\n  background-color: #f1f5f9;\n  border-color: var(--primary-color);\n  color: var(--primary-color);\n}\n\n.receipt-preview {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0.75rem;\n  background-color: #f8fafc;\n  border: 1px solid var(--border-color);\n  border-radius: 0.375rem;\n  margin-bottom: 1rem;\n}\n\n.receipt-file-info {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n}\n\n.image-preview {\n  width: 60px;\n  height: 60px;\n  border-radius: 0.25rem;\n  overflow: hidden;\n  border: 1px solid var(--border-color);\n  background-color: white;\n}\n\n.image-preview img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.file-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 60px;\n  height: 60px;\n  background-color: #eff6ff;\n  border-radius: 0.25rem;\n  color: var(--primary-color);\n}\n\n.file-details {\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n}\n\n.file-name {\n  font-size: 0.875rem;\n  font-weight: 500;\n  color: var(--text-primary);\n  max-width: 200px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.file-size {\n  font-size: 0.75rem;\n  color: var(--text-secondary);\n}\n\n.remove-file-button {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  background-color: #fee2e2;\n  border: none;\n  border-radius: 50%;\n  color: var(--error-color);\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.remove-file-button:hover {\n  background-color: #fecaca;\n}\n\n.payment-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 1rem;\n}\n\n.process-payment-button {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.75rem 1.5rem;\n  background-color: var(--primary-color);\n  color: white;\n  border: none;\n  border-radius: 0.375rem;\n  font-size: 0.875rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background-color 0.2s, opacity 0.2s;\n}\n\n.process-payment-button:hover:not(:disabled) {\n  background-color: var(--primary-hover);\n}\n\n.process-payment-button:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n/* Payment Confirmation Styles */\n.payment-confirmation {\n  padding: 1.5rem;\n}\n\n.payment-confirmation-header {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  padding: 1rem;\n  background-color: #fffbeb;\n  border-radius: 0.5rem;\n  margin-bottom: 1.5rem;\n  border-left: 4px solid var(--warning-color);\n}\n\n.payment-confirmation-header .confirmation-icon {\n  color: var(--warning-color);\n}\n\n.payment-confirmation-header p {\n  font-size: 0.875rem;\n  color: #92400e;\n}\n\n.payment-confirmation-details {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 1.5rem;\n}\n\n.payment-confirmation-section {\n  background-color: #f8fafc;\n  border-radius: 0.5rem;\n  padding: 1rem;\n  border: 1px solid var(--border-color);\n}\n\n.payment-confirmation-section h3 {\n  font-size: 0.875rem;\n  font-weight: 600;\n  margin-bottom: 0.75rem;\n  padding-bottom: 0.5rem;\n  border-bottom: 1px dashed var(--border-color);\n}\n\n.payment-confirmation-section p {\n  font-size: 0.875rem;\n  margin-bottom: 0.5rem;\n}\n\n.payment-confirmation-procedures {\n  list-style: none;\n  margin-top: 0.5rem;\n  max-height: 200px;\n  overflow-y: auto;\n}\n\n.payment-confirmation-procedures li {\n  display: flex;\n  justify-content: space-between;\n  font-size: 0.875rem;\n  padding: 0.5rem 0;\n  border-bottom: 1px dashed var(--border-color);\n}\n\n.payment-confirmation-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 1rem;\n  margin-top: 1.5rem;\n}\n\n.receipt-preview-confirmation {\n  margin-top: 0.5rem;\n  max-height: 200px;\n  overflow: hidden;\n  border-radius: 0.375rem;\n  border: 1px solid var(--border-color);\n}\n\n.receipt-preview-confirmation img {\n  width: 100%;\n  height: auto;\n  max-height: 200px;\n  object-fit: contain;\n}\n\n.receipt-section {\n  grid-column: span 2;\n}\n\n.back-button {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.75rem 1.5rem;\n  background-color: transparent;\n  border: 1px solid var(--border-color);\n  border-radius: 0.375rem;\n  color: var(--text-secondary);\n  font-size: 0.875rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.back-button:hover {\n  background-color: #f1f5f9;\n}\n\n.confirm-payment-button {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.75rem 1.5rem;\n  background-color: var(--success-color);\n  color: white;\n  border: none;\n  border-radius: 0.375rem;\n  font-size: 0.875rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.confirm-payment-button:hover {\n  background-color: #059669;\n}\n\n/* Payment Success Styles */\n.payment-success {\n  padding: 2rem;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n}\n\n.payment-success-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 80px;\n  height: 80px;\n  background-color: #ecfdf5;\n  border-radius: 50%;\n  color: var(--success-color);\n  margin-bottom: 1.5rem;\n}\n\n.payment-success h3 {\n  font-size: 1.25rem;\n  font-weight: 600;\n  margin-bottom: 0.5rem;\n  color: var(--success-color);\n}\n\n.payment-success p {\n  font-size: 0.875rem;\n  color: var(--text-secondary);\n  margin-bottom: 1.5rem;\n}\n\n.payment-success-details {\n  background-color: #f8fafc;\n  border-radius: 0.5rem;\n  padding: 1.5rem;\n  width: 100%;\n  max-width: 400px;\n  margin: 0 auto 1.5rem;\n  border: 1px solid var(--border-color);\n}\n\n.payment-success-info {\n  text-align: left;\n}\n\n.payment-success-info p {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 0.75rem;\n  font-size: 0.875rem;\n}\n\n.payment-success-receipt {\n  width: 100%;\n  max-width: 400px;\n  margin: 0 auto 1.5rem;\n}\n\n.payment-success-receipt h4 {\n  font-size: 0.875rem;\n  font-weight: 600;\n  margin-bottom: 0.75rem;\n  text-align: left;\n}\n\n.receipt-preview-success {\n  border-radius: 0.375rem;\n  border: 1px solid var(--border-color);\n  overflow: hidden;\n}\n\n.receipt-preview-success img {\n  width: 100%;\n  height: auto;\n  max-height: 200px;\n  object-fit: contain;\n}\n\n.payment-success-actions {\n  display: flex;\n  gap: 1rem;\n  margin-top: 1rem;\n}\n\n.print-receipt-button,\n.close-success-button {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.75rem 1.5rem;\n  border-radius: 0.375rem;\n  font-size: 0.875rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.print-receipt-button {\n  background-color: #f1f5f9;\n  border: 1px solid var(--border-color);\n  color: var(--text-primary);\n}\n\n.print-receipt-button:hover {\n  background-color: #e2e8f0;\n}\n\n.close-success-button {\n  background-color: var(--primary-color);\n  color: white;\n  border: none;\n}\n\n.close-success-button:hover {\n  background-color: var(--primary-hover);\n}\n\n/* Page Styles */\n.page-container {\n  max-width: 900px;\n  margin: 0 auto;\n  padding: 1.5rem;\n  background-color: var(--card-background);\n  border-radius: 0.5rem;\n  box-shadow: var(--shadow);\n}\n\n.page-header {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  margin-bottom: 1rem;\n  padding-bottom: 1rem;\n  border-bottom: 1px solid var(--border-color);\n}\n\n.page-header h1 {\n  font-size: 1.5rem;\n  font-weight: 600;\n}\n\n.back-button {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.5rem 0.75rem;\n  background-color: transparent;\n  border: 1px solid var(--border-color);\n  border-radius: 0.375rem;\n  color: var(--text-secondary);\n  font-size: 0.875rem;\n  cursor: pointer;\n  transition: background-color 0.2s, color 0.2s;\n}\n\n.back-button:hover {\n  background-color: #f1f5f9;\n  color: var(--text-primary);\n}\n\n/* Responsive Styles for Payment Modal */\n@media (max-width: 768px) {\n  .payment-methods-options {\n    flex-direction: column;\n  }\n\n  .payment-method-option {\n    width: 100%;\n  }\n\n  .payment-confirmation-details {\n    grid-template-columns: 1fr;\n  }\n\n  .discount-type-selector {\n    flex-direction: column;\n  }\n\n  .receipt-section {\n    grid-column: span 1;\n  }\n}\n\n@media print {\n  .modal-overlay {\n    position: static;\n    background: none;\n    padding: 0;\n  }\n\n  .payment-modal {\n    box-shadow: none;\n    max-width: 100%;\n    max-height: none;\n  }\n\n  .close-button,\n  .payment-actions,\n  .payment-success-actions {\n    display: none;\n  }\n\n  .payment-success {\n    padding: 0;\n  }\n}\n\n/* Adicionar estas regras de responsividade para o modal de pagamento */\n\n/* Ajustes gerais para telas médias */\n@media (max-width: 768px) {\n  .payment-modal {\n    max-width: 95%;\n    max-height: 95vh;\n  }\n\n  .payment-methods-options {\n    flex-direction: column;\n  }\n\n  .payment-method-option {\n    width: 100%;\n  }\n\n  .payment-confirmation-details {\n    grid-template-columns: 1fr;\n  }\n\n  .discount-type-selector {\n    flex-direction: column;\n    gap: 0.5rem;\n  }\n\n  .discount-type-option {\n    width: 100%;\n  }\n\n  .payment-total {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 0.5rem;\n  }\n\n  .payment-actions {\n    flex-direction: column;\n    gap: 0.5rem;\n  }\n\n  .payment-actions button {\n    width: 100%;\n  }\n\n  .payment-confirmation-actions {\n    flex-direction: column;\n    gap: 0.5rem;\n  }\n\n  .payment-confirmation-actions button {\n    width: 100%;\n  }\n\n  .payment-success-actions {\n    flex-direction: column;\n    gap: 0.5rem;\n  }\n\n  .payment-success-actions button {\n    width: 100%;\n  }\n}\n\n/* Ajustes para telas pequenas */\n@media (max-width: 480px) {\n  .procedures-modal {\n    max-width: 100%;\n    max-height: 100vh;\n    border-radius: 0;\n  }\n\n  .modal-overlay {\n    padding: 0;\n  }\n\n  .payment-patient-info {\n    flex-direction: column;\n    gap: 0.5rem;\n    align-items: flex-start;\n  }\n\n  .payment-procedure-item {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .payment-procedure-checkbox {\n    align-self: flex-start;\n    margin-bottom: 0.5rem;\n  }\n\n  .payment-procedure-price {\n    align-self: flex-end;\n    margin-top: 0.5rem;\n  }\n\n  .payment-procedures-list {\n    padding: 0.75rem;\n  }\n\n  .payment-summary {\n    padding: 0.75rem;\n  }\n\n  .payment-discount-section {\n    padding: 0.75rem;\n  }\n\n  .payment-methods {\n    padding: 0.75rem;\n  }\n\n  .payment-actions {\n    padding: 0.75rem;\n  }\n\n  .custom-total-input input {\n    width: 100%;\n  }\n}\n\n/* Ajustes específicos para a seção de desconto */\n.payment-discount-section {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n\n.discount-options {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n\n@media (min-width: 769px) {\n  .discount-options {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 1rem;\n  }\n}\n\n/* Melhorar a visualização da lista de procedimentos em telas pequenas */\n@media (max-width: 600px) {\n  .payment-procedure-meta {\n    flex-direction: column;\n    gap: 0.25rem;\n  }\n\n  .payment-procedure-item {\n    padding: 0.5rem;\n  }\n\n  .payment-procedure-details h4 {\n    font-size: 0.8rem;\n  }\n\n  .payment-procedure-meta {\n    font-size: 0.7rem;\n  }\n}\n\n/* Ajustes para o modo de edição do valor total */\n@media (max-width: 600px) {\n  .payment-total {\n    flex-wrap: wrap;\n  }\n\n  .custom-total-input {\n    width: 100%;\n    margin-top: 0.5rem;\n  }\n\n  .custom-total-input input {\n    width: 100%;\n  }\n}\n\n/* Melhorar a visualização da confirmação em telas pequenas */\n@media (max-width: 600px) {\n  .payment-confirmation {\n    padding: 0.75rem;\n  }\n\n  .payment-confirmation-header {\n    padding: 0.75rem;\n    flex-direction: column;\n    text-align: center;\n  }\n\n  .payment-confirmation-section {\n    padding: 0.75rem;\n  }\n}\n\n/* Ajustes para a tela de sucesso em dispositivos pequenos */\n@media (max-width: 600px) {\n  .payment-success {\n    padding: 1rem;\n  }\n\n  .payment-success-icon {\n    width: 60px;\n    height: 60px;\n  }\n\n  .payment-success h3 {\n    font-size: 1.1rem;\n  }\n\n  .payment-success-details {\n    padding: 1rem;\n  }\n}\n\n/* Ajustes para o modal de procedimentos agendados */\n.scheduled-procedures-modal {\n  max-width: 800px;\n  display: flex;\n  flex-direction: column;\n  height: 90vh;\n}\n\n.scheduled-procedures-list {\n  padding: 1rem 1.5rem;\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n/* Garantir que o conteúdo do modal tenha rolagem */\n.modal-content-scrollable {\n  flex: 1;\n  overflow-y: auto;\n  padding-bottom: 1rem;\n}\n\n/* Garantir que o rodapé fique fixo */\n.modal-footer {\n  display: flex;\n  justify-content: flex-end;\n  gap: 0.75rem;\n  padding: 1rem 1.5rem;\n  border-top: 1px solid var(--border-color);\n  background-color: var(--card-background);\n  flex-shrink: 0;\n}\n\n/* Ajustes para o modal de agendamento */\n.scheduling-page {\n  max-height: 90vh;\n  overflow-y: auto;\n}\n\n.form-actions {\n  position: sticky;\n  bottom: 0;\n  background-color: var(--card-background);\n  padding: 1rem 0;\n  margin-top: 1rem;\n  border-top: 1px solid var(--border-color);\n  display: flex;\n  justify-content: flex-end;\n  gap: 1rem;\n  z-index: 10;\n}\n\n/* Ajustes responsivos para telas pequenas */\n@media (max-width: 768px) {\n  .scheduled-procedure-header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 0.5rem;\n  }\n\n  .scheduled-date-time {\n    flex-direction: column;\n    gap: 0.25rem;\n  }\n\n  .scheduled-procedure-actions {\n    flex-wrap: wrap;\n    gap: 0.5rem;\n  }\n\n  .scheduled-procedure-actions button {\n    flex: 1 0 auto;\n    min-width: 120px;\n  }\n}\n\n@media (max-width: 480px) {\n  .scheduled-procedures-list {\n    padding: 0.75rem;\n  }\n\n  .scheduled-procedure-card {\n    padding: 0;\n  }\n\n  .scheduled-procedure-content {\n    padding: 0.75rem;\n  }\n\n  .scheduled-procedures li {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 0.25rem;\n  }\n\n  .scheduled-procedure-actions {\n    flex-direction: column;\n  }\n\n  .scheduled-procedure-actions button {\n    width: 100%;\n  }\n}\n\n/* Ajustes para a página de confirmação */\n.confirmation-page {\n  max-height: 90vh;\n  overflow-y: auto;\n}\n\n.confirmation-actions {\n  position: sticky;\n  bottom: 0;\n  background-color: var(--card-background);\n  padding: 1rem 0;\n  margin-top: 1rem;\n  border-top: 1px solid var(--border-color);\n  display: flex;\n  justify-content: flex-end;\n  gap: 1rem;\n  z-index: 10;\n}\n\n/* Ajustes responsivos para a página de confirmação */\n@media (max-width: 768px) {\n  .confirmation-details {\n    grid-template-columns: 1fr;\n  }\n\n  .confirmation-actions {\n    flex-direction: column;\n    gap: 0.75rem;\n  }\n\n  .confirmation-actions button {\n    width: 100%;\n  }\n}\n\n/* Ajustes para garantir que os botões sejam sempre visíveis em telas pequenas */\n@media (max-height: 700px) {\n  .form-actions,\n  .confirmation-actions,\n  .modal-footer {\n    position: sticky;\n    bottom: 0;\n    background-color: var(--card-background);\n    padding: 0.75rem;\n    margin-top: 0.75rem;\n    z-index: 10;\n  }\n}\n\n@media (max-height: 800px) {\n  .button-cashier {\n  }\n  .app-container {\n    height: 80vh;\n    overflow-y: auto;\n    margin: 0 auto;\n    padding: 1rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
